export class FocusView {
    public general: boolean = false;
    public priceDimension: boolean = false;
}